import React from 'react'
import { ListItem, ListItemAvatar, Avatar, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';
import FrontendRoutes from "../../../constants/FrontendRoutes";
import CommentIcon from '@material-ui/icons/Comment';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {},
    listItem: {
      '&:hover': {
        backgroundColor: theme.palette.background.default
      }
    },
    avatarBlue: {
      backgroundColor: "blue"
    },
    avatarGreen: {
        backgroundColor: "green"
    },
    avatarOrange: {
        backgroundColor: "orange"
    },
    avatarIndigo: {
        backgroundColor: "indigo"
    },
    avatarRed: {
        backgroundColor: "red"
    },
}));

function Comment({comment, payload}) {
    const classes = useStyles()
    const { t } = useTranslation();
    const dispatch = useDispatch();

    let primaryText;
    let routeTo;

    return (
        <ListItem
            className={classes.listItem}
            component={RouterLink}
            key={comment.getCreatedAt()}
            to={FrontendRoutes.posts.show(comment.getPostId())}
        >
        <ListItemAvatar>
        {   
            <Avatar className={classes.avatarBlue}>
                <CommentIcon />
            </Avatar>
        }
        </ListItemAvatar>
        <ListItemText
            primary={`New Comments in Post`}
            primaryTypographyProps={{ variant: 'body1' }}
            secondary={moment(comment.getRawCreatedAt()).fromNow()}
        />
    </ListItem>
    )}

export default Comment
